import React, { useEffect, useState } from "react";
import Sections from "./Sections";
import { useTranslation } from "../../i18n/LanguageContext";
import { translateGenderName } from "../../base/utils/genderLabels";
const EditProfileNgoMember = ({
   isEditMode,
   handleChange,
   values,
   genders,
   setFieldValue,
   errors,
   touched
}) => {
   const { t } = useTranslation();
   const [selectedGender, setSelectedGender] = useState(values?.genderId);

   useEffect(() => {
      setSelectedGender(values?.genderId);
   }, [values]);

   // Derived at render time (not baked into `genders` state) so switching
   // language re-translates the dropdown/display immediately.
   const genderOptions = (genders || []).map((gender) => ({
      value: gender.value,
      label: translateGenderName(gender.name, t)
   }));

   const getGenderName = (id) => {
      const gender = genderOptions?.find((gen) => gen?.value === id);
      return gender ? gender?.label : "";
   };

   const fields = [
      {
         sectionName: t("personal-information-title"),
         propertyName: t("name-label"),
         name: "name",
         propertyValue: values?.name,
         isEditMode: isEditMode,
         handleChange: handleChange,
         isRequired: true
      },
      {
         sectionName: "",
         propertyName: t("birthdate-label"),
         name: "birthday",
         fieldType: "date",
         propertyValue: values?.birthday,
         isEditMode: isEditMode,
         onSelectChange: (dateString) => {
            setFieldValue("birthday", dateString);
         },
         isRequired: false
      },
      {
         propertyName: t("gender-label"),
         name: "genderId",
         propertyValue: isEditMode ? selectedGender : getGenderName(selectedGender),
         isEditMode: isEditMode,
         handleChange: handleChange,
         fieldType: "selectNationality",
         options: genderOptions,
         onSelectChange: (selectedOption) => {
            setFieldValue("genderId", selectedOption);
         },
         isRequired: true
      }
   ];

   return (
      <>
         {fields?.map((section, index) => (
            <div key={index}>
               <Sections {...section} />
               {errors[section.name] && touched[section.name] && (
                  <div className="text-danger">{errors[section.name]}</div>
               )}
            </div>
         ))}
      </>
   );
};

export default EditProfileNgoMember;
